import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;

  max-width: 100%;
`;
